import React from "react";
import "./Gallery.css";

import ceo1 from "./images/ceo1.jpeg";
import ca2 from "./images/ca2.jpeg";

import team2 from "./images/team2.jpeg";
import team3 from "./images/mketech team3.jpeg";

import industrial1 from "./images/college industrial visit1.jpeg";
import industrial2 from "./images/team.jpeg";
import industrial3 from "./images/college industrial visit3.jpeg";

import collegeevent1 from "./images/college event1.jpeg";
import collegeevent2 from "./images/college event2.jpeg";
import collegeevent3 from "./images/college event3.jpeg";

import other1 from "./images/raosaheb danve1.jpeg";
import other2 from "./images/raosaheb danve2.jpeg";
import { Helmet } from "react-helmet";

const Gallery = () => {
  const ceoInfo = {
    name: "Mr. ABHISSEK PATNI",
    position: "Managing Director / CEO & Founder",
    description: `
    <h3>Driving Innovation in Technology: The Leadership Behind MK e-Tech Private Limited</h3>
    <p>In today’s rapidly evolving digital landscape, businesses require cutting-edge solutions and strong leadership to stay ahead. 
    <strong>MK e-Tech Private Limited</strong>, a fast-growing software company, has emerged as a trusted partner for organizations 
    seeking technology-driven transformation. At the helm of this dynamic enterprise is 
    <strong>Mr. Abhisshek Patni</strong>, the Managing Director (MD), Chief Executive Officer (CEO), and Founder of the company.</p>

    <h3>Visionary Leadership</h3>
    <p>With a clear vision to revolutionize the way businesses leverage technology, Mr. Patni established MK e-Tech Private Limited 
    with innovation, reliability, and client-centric service at its core. His leadership combines strategic foresight with 
    hands-on expertise, driving the company toward sustainable growth and long-term success.</p>

    <h3>A Trusted Software Partner</h3>
    <p>MK e-Tech specializes in providing end-to-end IT solutions, offering services such as:</p>
    <ul>
      <li>Custom Software Development tailored to client needs</li>
      <li>Web and Mobile Applications with modern, user-friendly interfaces</li>
      <li>Enterprise Solutions that enhance business efficiency</li>
      <li>Cloud and IT Consulting Services for seamless digital adoption</li>
    </ul>
    <p>By focusing on quality, scalability, and innovation, the company has built a strong reputation among clients across 
    various industries.</p>

    <h3>Building a Culture of Innovation</h3>
    <p>Under Mr. Patni’s leadership, MK e-Tech fosters a work culture where creativity and technical excellence go hand in hand. 
    The company’s team of skilled professionals is encouraged to think beyond conventional boundaries, ensuring clients 
    benefit from future-ready solutions.</p>

    <h3>The Road Ahead</h3>
    <p>As the technology landscape continues to evolve, MK e-Tech Private Limited remains committed to empowering businesses 
    with innovative solutions. Guided by the visionary leadership of Abhisshek Patni, the company aims to expand its 
    global footprint, strengthen client relationships, and continue delivering excellence in the software industry.</p>
  `,
    image: ceo1,
  };

  const caInfo = {
    name: " Mrs. ADITI PATNI",
    position: "Chartered Accountant",
    description: `
    <h2 class="ca-heading">Financial Leadership & Excellence</h2>
    <p>As the <strong>Chartered Accountant</strong> of <strong>MK e-Tech Private Limited</strong>, 
    Mrs. Aditi Patni plays a crucial role in ensuring financial stability, transparency, and compliance within the organization.</p>

    <h3>Financial Expertise</h3>
    <p>With her deep knowledge of accounting, taxation, and auditing practices, she ensures that the company adheres to 
    the highest financial standards while supporting strategic growth and profitability.</p>

    <h3>Operational Excellence</h3>
    <p>Mrs. Patni is actively involved in streamlining financial operations, implementing effective internal controls, 
    and guiding the management in making sound financial decisions.</p>

    <h3>Commitment to Growth</h3>
    <p>Her dedication to maintaining fiscal discipline and fostering sustainable business practices makes her an 
    integral part of MK e-Tech’s leadership team, contributing to the company’s long-term success.</p>
  `,
    image: ca2,
  };

  const collegeEvents = [
    {
      id: 1,
      title: "",
      description: "",
      image: collegeevent1,
    },
    {
      id: 2,
      title: "",
      description: "",
      image: collegeevent2,
    },
    {
      id: 3,
      title: "",
      description: "",
      image: collegeevent3,
    },
    {
      id: 4,
      title: "",
      description: "",
      image: industrial1,
    },
    {
      id: 5,
      title: "",
      description: "",
      image: industrial2,
    },
    {
      id: 6,
      title: "",
      description: "",
      image: industrial3,
    },
    {
      id: 7,
      name: "",
      position: "",
      image: team3,
    },
    {
      id: 8,
      name: "",
      position: "",
      image: team2,
    },
  ];

  const OtherEvents = [
    {
      id: 1,
      title: "",
      description: "",
      image: other1,
    },
    {
      id: 2,
      title: "",
      description: "",
      image: other2,
    },
  ];

  return (
    <div>
      <Helmet>
        <title>E-Tech Gallery | Leadership, Team & Events</title>
        <meta
          name="description"
          content="Explore E-Tech's leadership team, company events, industrial visits, and our innovative projects. Meet our CEO, CA, and talented professionals driving technology forward."
        />
        <meta
          name="keywords"
          content="E-Tech, technology company, CEO, CA, team gallery, industrial visits, college events, tech leadership, IT company, IT solutions, technology services, software development, digital transformation, tech innovation, IT consulting, custom software development, cloud solutions, cybersecurity services, data analytics, tech leadership, management team, CEO profile, Chief Administrative Officer, software engineers, development team, UX designers, project managers, tech talent, corporate events, tech workshops, hackathons, seminars, industry partnerships, campus recruitment, tech tours, facility tours, innovation labs, data centers, manufacturing plants, R&D centers"
        />
        <meta name="author" content="E-Tech" />
        <meta
          property="og:title"
          content="E-Tech Gallery | Leadership, Team & Events"
        />
        <meta
          property="og:description"
          content="Explore E-Tech's leadership team, company events, industrial visits, and our innovative projects."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.mketech.in/gallery" />
        <meta
          property="og:image"
          content="https://www.mketech.in/images/og-gallery-image.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="E-Tech Gallery | Leadership, Team & Events"
        />
        <meta
          name="twitter:description"
          content="Explore E-Tech's leadership team, company events, and innovative projects."
        />
        <meta
          name="twitter:image"
          content="https://www.mketech.in/images/twitter-gallery-image.jpg"
        />
        <link rel="canonical" href="https://www.mketech.in/gallery" />
      </Helmet>

      <main className="gallery-main">
        {/* CEO Section */}
        <section className="section">
          <h2 className="section-title-gallery">Management</h2>
          <div className="ceo-container">
            <div className="ceo-image">
              <img src={ceoInfo.image} alt={ceoInfo.name} />
              {/* Naam & Position ab image ke niche */}
              <h3>{ceoInfo.name}</h3>
              <p className="position">{ceoInfo.position}</p>
            </div>
            <div className="ceo-info">
              <div
                className="ceo-description"
                dangerouslySetInnerHTML={{ __html: ceoInfo.description }}
              />
            </div>
          </div>
        </section>

        {/* CA Section */}
        <section className="section">
          <h2 className="section-title-gallery"></h2>
          <div className="ca-container">
            <div className="ca-image">
              <img src={caInfo.image} alt={caInfo.name} />
              {/* Naam & Position ab image ke niche */}
              <h3>{caInfo.name}</h3>
              <p className="position">{caInfo.position}</p>
            </div>
            <div className="ca-info">
              <div className="ca-description">
                <div
                  className="ca-description"
                  dangerouslySetInnerHTML={{ __html: caInfo.description }}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="section-poly">
          <h2 className="section-title-gallery">
            Moments of Leadership, Captured Forever
          </h2>
          <div className="gallery-grid-poly">
            {OtherEvents.map((event, index) => (
              <React.Fragment key={event.id}>
                <div className="gallery-card-poly">
                  <div className="gallery-image-poly">
                    <img src={event.image} alt={event.title} />
                  </div>
                  <div className="gallery-info-poly">
                    <h3>{event.title}</h3>
                    <p>{event.description}</p>
                  </div>
                </div>

                {index === 0 && (
                  <div className="gallery-middle-info-poly">
                    <p>
                      <strong>Shree Raosaheb Danve (Dada)</strong>
                      <br />
                      Is an Indian politician and former Member of Parliament
                      from Jalna, Minister of State in the Ministry of Railways,
                      Ministry of Coal and Ministry of Mines in Second Modi
                      ministry
                    </p>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Thanking Message */}
          <div className="thank-message-poly">
            <p>
              🙏 MK e-Tech Private Limited extends heartfelt gratitude to{" "}
              <strong>Shree Raosaheb Danve (Dada)</strong> for his constant
              guidance, encouragement, and invaluable support. His leadership
              continues to inspire us in our journey of innovation and
              excellence.
            </p>
          </div>
        </section>

        {/* College Events Section */}
        <section className="section">
          <h2 className="section-title-gallery">
            Showcasing Excellence, Frame by Frame
          </h2>
          <div className="gallery-grid">
            {collegeEvents.map((event) => (
              <div key={event.id} className="gallery-card">
                <div className="gallery-image">
                  <img src={event.image} alt={event.title} />
                </div>
                <div className="gallery-info">
                  <h3>{event.title}</h3>
                  <p>{event.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default Gallery;
